// imports
import { fetchMsPlansApi, checkoutMsPlanApi } from 'api/msPlans';
import { notify } from 'redux/actions/notice';
// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_MS_PLANS_START = 'FETCH_MS_PLANS_START';
export const FETCH_MS_PLANS_END = 'FETCH_MS_PLANS_END';
export const CHECKOUT_MS_PLANS_START = 'CHECKOUT_MS_PLANS_START';
export const CHECKOUT_MS_PLANS_END = 'CHECKOUT_MS_PLANS_END';
export const MS_PLANS_ERROR = 'MS_PLANS_ERROR';
// ------------------------------------
// Actions
// ------------------------------------

export function fetchMsPlansStart() {
  return ({ type: FETCH_MS_PLANS_START });
}

export function fetchMsPlansEnd(payload) {
  return ({ type: FETCH_MS_PLANS_END, payload });
}

export function checkoutMsPlanStart() {
  return ({ type: CHECKOUT_MS_PLANS_START });
}

export function checkoutMsPlanEnd() {
  return ({ type: CHECKOUT_MS_PLANS_END });
}

export function raiseErrorMsPlans() {
  return ({ type: MS_PLANS_ERROR });
}

export function checkoutMsPlan(plan, done = () => { }) {
  return (dispatch, getState) => {
    const { i18n: { info: { locale } } } = getState();
    dispatch(checkoutMsPlanStart());
    checkoutMsPlanApi(plan.planID, locale)
      .then((res = {}) => {
        const resBody = res.body;
        done(null, resBody);
        dispatch(checkoutMsPlanEnd());
      })
      .catch((error) => {
        dispatch(notify({ error }));
        dispatch(checkoutMsPlanEnd());
        done(error);
      });
  };
}
export function loadMsPlans(urlInfo) {
  return (dispatch) => {
    dispatch(fetchMsPlansStart());
    // api call
    fetchMsPlansApi(urlInfo)
      .then((res) => {
        dispatch(fetchMsPlansEnd(res));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/msPlans.js